import { type ModalRegistration } from '@/shared/components/Modals/modal-registry/modal-registry.types';

import { BanUserModal } from '../BanUserModal/BanUserModal';
import { ChangeStatusModal } from '../ChangeStatusModal/ChangeStatusModal';
import { SuspendUserModal } from '../SuspendUserModal/SuspendUserModal';

/**
 * The kit's account dialog TYPES (P27c1).
 *
 * Global strings, so they carry the `account.` prefix: the registry throws on a
 * collision rather than letting whichever registered last silently win. A
 * module opens one by dispatching the string — the staff page and the members
 * page both do — and imports nothing of the dialog (W2).
 */
export const ACCOUNT_MODALS = {
  SUSPEND: 'account.suspend',
  BAN: 'account.ban',
  CHANGE_STATUS: 'account.change-status',
} as const;

/** What every account dialog is opened with — ids only, never a callback. */
export interface AccountModalData {
  userId: string;
  email: string;
}

/** The registrations `app.config.tsx` installs, beside the modules' own. */
export const accountModals: readonly ModalRegistration[] = [
  { modalTypes: [ACCOUNT_MODALS.SUSPEND], component: SuspendUserModal },
  { modalTypes: [ACCOUNT_MODALS.BAN], component: BanUserModal },
  { modalTypes: [ACCOUNT_MODALS.CHANGE_STATUS], component: ChangeStatusModal },
];
